import React, { memo, FC } from "react";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { UnitObj } from "../../util/quoteCartStorage";

const StyledTypography = styled(Typography)({
  display: "inline",
  fontFamily: "Arial",
  color: "black",
});

const StyledDivRow = styled("div")({
  display: "flex",
  flexDirection: "row",
});

function sizeFormat(num?: string, fraction?: string) {
  if(!num) return ""

  if (fraction) {
    return ` ${num} ${fraction}"`;
  }

  return ` ${num}"`;
}

function comboHeight(unitType: string | undefined, unit: UnitObj){
  if(!unitType) return ""

  if(unitType === "Door"){
    return sizeFormat(unit.height, unit.heightFraction)
  }
  return sizeFormat(unit.comboWindowHeight, unit.comboWindowHeightFraction)
}

function comboWidth(unitType: string | undefined, unit: UnitObj){
  if(!unitType) return ""

  if(unitType === "Door"){
    return sizeFormat(unit.unitSize, unit.unitSizeFraction)
  }
  return sizeFormat(unit.comboWindowUnitSize, unit.comboWindowUnitSizeFraction)
}

function comboConfig(unitType: string | undefined, unit: UnitObj){
  if(!unitType) return ""

  if(unitType === "Door"){
    return unit.exactConfig + " Door"
  }

  return unit.comboWindowConfig + " Window"
}

interface QuoteListProps {
  unit: UnitObj;
  checked: boolean;
}

const QuoteList: FC<QuoteListProps> = ({ unit, checked }) => {
  return (
    <>
      {unit.location && (
        <ListItem label="Location:" label2={` ${unit.location}`} />
      )}
      <ListItem
        label={"Width:"}
        label2={
          unit.doorType.includes("Corner")
            ? ` L-${sizeFormat(
                unit.unitSize,
                unit.unitSizeFraction || ""
              )} R-${sizeFormat(
                unit.cornerWidthRight || "",
                unit.cornerWidthFractionRight || ""
              )}`
            : unit.doorType.includes("Combo")
            ? ` L-${comboWidth(unit.comboUnitLeft, unit)} R-${comboWidth(unit.comboUnitRight, unit)}`
            : sizeFormat(unit.unitSize, unit.unitSizeFraction || "")
        }
      />

      {unit.doorType?.includes("Combo") ? (
        <ListItem
        label={"Height:"}
        label2={` L-${comboHeight(unit.comboUnitLeft, unit)} R-${comboHeight(unit.comboUnitRight, unit)}`}
      />
      ) : (
        <ListItem
        label={"Height:"}
        label2={sizeFormat(unit.height, unit.heightFraction || "")}
      />
      )}
      {unit.doorType === "Fixed Panel" ? (
        <ListItem label={"Configuration:"} label2={" " + unit.exactConfig} />
      ) : unit.doorType.includes("Bi-fold") ? (
        <ListItem
          label={"Configuration:"}
          label2={
            unit.doorType.includes("Corner")
              ? " " +
                unit.cornerType +
                " " +
                unit.exactConfig +
                " " +
                unit.cornerConfigRight
              : unit.doorType?.includes("Combo")
              ? `${comboConfig(unit.comboUnitLeft, unit)} ${comboConfig(unit.comboUnitRight, unit)}`
              : unit.exactConfig
              ? " " + unit.exactConfig
              : " " + unit.configuration
          }
        />
      ) : unit.doorType === "Slider" ? (
        <ListItem
          label={"Configuration:"}
          label2={
            unit.exactConfig && " " + unit.exactConfig.replace("Right", "R")
          }
        />
      ) : unit.doorType === "Pivot" ? (
        <ListItem label={"Configuration:"} label2={` ${unit.exactConfig}`} />
      ) : (
        <ListItem
          label={"Configuration:"}
          label2={` ${unit.exactConfig.split(" ")[1]} ${unit.exactConfig
            .split(" ")
            .splice(-1, 1)}`}
        />
      )}
      {unit.material !== "All Aluminum" ? (
        <>
          <ListItem label={"Wood:"} label2={` ${unit.woodAbbrev}`} />
          {checked && (
            <StyledDivRow>
              <StyledTypography
                style={{ fontWeight: "bold" }}
                variant="body2"
              >
                Price:
              </StyledTypography>
              <StyledTypography
                style={{ marginLeft: 5, color: "rgba(0, 0, 0, 0.6)" }}
                variant="body2"
              >
                ${unit.price}
              </StyledTypography>
            </StyledDivRow>
          )}
        </>
      ) : (
        <>
          {checked && (
            <StyledDivRow>
              <StyledTypography
                style={{ fontWeight: "bold" }}
                variant="body2"
              >
                Price:
              </StyledTypography>
              <StyledTypography
                style={{ marginLeft: 5, color: "rgba(0, 0, 0, 0.6)" }}
                variant="body2"
              >
                ${unit.price}
              </StyledTypography>
            </StyledDivRow>
          )}
        </>
      )}
    </>
  );
};

interface ListItemProps {
  label: string;
  label2: string;
}

const ListItem: FC<ListItemProps> = ({ label, label2 }) => {
  return (
    <StyledDivRow>
      <StyledTypography variant="body2">{label}</StyledTypography>
      <StyledTypography
        style={{ marginLeft: 5, color: "rgba(0, 0, 0, 0.6)" }}
        variant="body2"
      >
        {label2}
      </StyledTypography>
    </StyledDivRow>
  );
};

export default memo(QuoteList);
